"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1() {
    const deliveryRegion = (0, react_redux_1.useSelector)((state) => state.roomData.delivery_region);
    const isRoomPrepared = (0, react_redux_1.useSelector)((state) => state.isRoomPrepared);
    const pendingRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        return () => {
            pendingRef.current = false;
        };
    }, []);
    const dispatch = (0, react_redux_1.useDispatch)();
    const goToNextStep = () => dispatch((0, roomCreateStore_1.setRoomCreateStep)('2'));
    const createRoom = () => __awaiter(this, void 0, void 0, function* () {
        if (!pendingRef.current) {
            pendingRef.current = true;
            const canCreateRoom = yield (0, _1.roomCreateCheck)({ fromUrlParam: '/room_create_new/' });
            if (canCreateRoom) {
                dispatch((0, roomCreateStore_1.createNewRoom)({ roomType: '굿즈', deliveryRegion }));
            }
            else {
                pendingRef.current = false;
            }
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { position: 'absolute', bottom: 0, width: '100%', maxWidth: '1024px', padding: '20px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                width: '100%',
                height: '56px',
                padding: '0 36px',
                borderRadius: '12px',
                bgcolor: 'var(--primary-main) !important',
                color: 'var(--white)',
            }, onClick: () => {
                if (isRoomPrepared) {
                    goToNextStep();
                }
                else {
                    createRoom();
                }
            } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('폼 만들기') })) })) })));
}
exports.default = default_1;
